export default {
  animationEasing: 'quarticInOut',
  grid: {
    left: '0',
    right: '0',
    top: '0%',
    bottom: '18%',
    containLabel: false
  },
  xAxis: {
    type: 'category',
      data: [],
      axisPointer: {
        type: 'shadow'
      },
    axisTick: {
      show: false
    },
    axisLabel: {
      color: '#61697E',
        fontSize: 10
    },
    axisLine: { }
  },
  yAxis: [
    {
      type: 'value',
      show: false,
      boundaryGap: ['0%', '12%']
    },
    {
      type: 'value',
      show: false,
      boundaryGap: ['0%', '12%']
    }
  ],
  series: [
    {
      name: '营业收入',
      type: 'bar',
      barWidth: 30,
      label: {
        color: '#596E98',
        position: 'top',
        show: true,
        formatter: (value) => {
          return Math.abs(Number.parseFloat(value.data)) < 10000 ? `${value.data}万` : `${(value.data / 10000).toFixed(1)}亿`
        }
      },
      itemStyle: {
        color: '#2881CD'
      },
      data: []
    },
    {
      name: '同比增长',
      type: 'line',
      yAxisIndex: 1,
      symbol: 'circle',
      symbolSize: 6,
      data: [],
      lineStyle: {
        color: '#FFA839',
        width: 1
      },
      itemStyle: {
        color: '#FFA839'
      },
      label: {
        show: false,
        position: 'top',
        color: '#FFA839',
        fontSize: 11,
        formatter: `{c}%`
      }
    }
  ]
}